import { GraphEntityType } from '@api/api/ontology';
import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { useQuery } from '@tanstack/react-query';
import { getGraphIntersections } from '@terminal/views/graph/services/graph-service';

export const QUERY_KEY_GRAPH_INTERSECTIONS = 'QUERY_KEY_GRAPH_INTERSECTIONS';

export const useGraphIntersections = ({
  node,
  nodeType,
  targetRelation,
  limit,
}: {
  node: string;
  nodeType: GraphEntityType;
  targetRelation: string;
  limit?: number;
}) => {
  return useQuery({
    queryKey: [
      QUERY_KEY_GRAPH_INTERSECTIONS,
      node,
      nodeType,
      targetRelation,
      limit,
    ],
    queryFn: () =>
      getGraphIntersections({
        node,
        nodeType,
        targetRelation,
        limit,
      }),
    staleTime: getTimeTillEndOfDayMs(),
  });
};
